module.exports = __webpack_public_path__ + "static/img/2.72f188d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/2.png
// module id = rwBY
// module chunks = 0